import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { BaseApiResponse } from 'app/core/models/api/api.model';
import { ImmunizationStatus } from 'app/core/models/immunization-status/immunization-status.model';
import { environment } from '../../../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ImmunizationStatusService {
  constructor(private apiService: ApiService) {}

  async getListImmunizationStatus(): Promise<
    BaseApiResponse<ImmunizationStatus[]>
  > {
    return await firstValueFrom(
      this.apiService.get<ImmunizationStatus[]>(
        `${environment.apiLocations.patient}/immunizationstatus`
      )
    );
  }
}
